export const isValidCalendarWeekRange = (week) => {
  if (!week?.start_date || !week?.end_date) return false;
  const start = new Date(week.start_date);
  const end = new Date(week.end_date);
  return !Number.isNaN(start.getTime()) && !Number.isNaN(end.getTime()) && end > start;
};

export const getCurrentWeek = (calendar) => {
    if (!calendar || calendar.length === 0) {
      return 1;
    }

    const today = new Date();
    const visibleWeeks = calendar.filter((week) => !week.hide_week && isValidCalendarWeekRange(week));
    if (visibleWeeks.length === 0) {
      return 1;
    }

    // Sort calendar by start_date to ensure proper order
    const sortedCalendar = [...visibleWeeks].sort((a, b) => new Date(a.start_date) - new Date(b.start_date));

    // Find the first week (preseason check)
    const firstWeek = sortedCalendar[0];
    const firstWeekStart = new Date(firstWeek.start_date);

    // Find the last week (postseason check)
    const lastWeek = sortedCalendar[sortedCalendar.length - 1];
    const lastWeekEnd = new Date(lastWeek.end_date);

    // Check if we're in preseason (before the first week starts)
    if (today < firstWeekStart) {
      return 1;
    }

    // Check if we're in postseason (after the last week ends)
    if (today > lastWeekEnd) {
      return lastWeek.week;
    }

    // Normal in-season logic - prefer regular-season weeks on overlap
    const matchingWeeks = sortedCalendar.filter(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      return today >= startDate && today <= endDate;
    });
    const regularMatch = matchingWeeks.find(week => week.season_type === 'regular');
    if (regularMatch) {
      return regularMatch.week;
    }
    if (matchingWeeks[0]) {
      return matchingWeeks[0].week;
    }

    // Fallback: if we're between weeks, find the next upcoming week
    const nextWeek = sortedCalendar.find(week => {
      const startDate = new Date(week.start_date);
      return today < startDate;
    });

    if (nextWeek) {
      return nextWeek.week;
    }

    // Ultimate fallback
    return 1;
  };

export const formatGameDate = (dateString) => {
  try {
    // Parse ISO date string (YYYY-MM-DD)
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      console.error('Invalid date string:', dateString);
      return 'Invalid Date';
    }

    // Format to "Day, Month DD" (e.g., "Thu, Sep 14")
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error, 'for date string:', dateString);
    return 'Invalid Date';
  }
};
